
import React from 'react';
import { useForm, type SubmitHandler } from 'react-hook-form';
import { studentService } from '../../../services/student.service';
import type { StudentFormData } from '../../../types/student';

interface AddStudentFormProps {
  classId: string;
  onSuccess: () => void;
}

export const AddStudentForm: React.FC<AddStudentFormProps> = ({ classId, onSuccess }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm<StudentFormData>();

  const onSubmit: SubmitHandler<StudentFormData> = async (data) => {
    try {
      await studentService.addStudentToClass(classId, data);
      alert('수강생이 성공적으로 추가되었습니다.');
      reset(); // 폼 초기화
      onSuccess(); // 부모 컴포넌트에 알림
    } catch (error) {
      console.error("수강생 추가 중 오류:", error);
      alert("수강생 추가 중 오류가 발생했습니다.");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div>
        <label htmlFor="studentName" className="block text-base font-normal text-gray-600">
          수강생 이름
        </label>
        <input
          id="studentName"
          type="text"
          {...register("name", { required: "수강생 이름은 필수 항목입니다." })}
          className={`mt-1 block w-full border shadow-sm rounded-md p-2 ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:ring-blue-500 focus:border-blue-500`}
          aria-invalid={errors.name ? "true" : "false"}
        />
        {errors.name && (
          <p className="mt-1 text-sm text-red-500" role="alert">
            {errors.name.message}
          </p>
        )}
      </div>
      
      {/* 필요에 따라 추가 필드 (예: 연락처) */}
      {/* <div>
        <label htmlFor="studentContact" className="block text-base font-normal text-gray-600">
          연락처 (선택)
        </label>
        <input
          id="studentContact"
          type="text"
          {...register("contact")}
          className="mt-1 block w-full border border-gray-300 shadow-sm rounded-md p-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div> */}

      <div className="flex justify-end pt-4 border-t mt-6">
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-1.5 bg-btn-green-bg hover:bg-btn-green-hover text-white font-medium rounded-lg shadow-xl focus:outline-none focus:ring-2 focus:ring-btn-green-bg focus:ring-opacity-50 transition duration-150 ease-in-out disabled:opacity-50"
        >
          {isSubmitting ? '추가 중...' : '추가하기'}
        </button>
      </div>
    </form>
  );
};
